export const isString = val => typeof val === 'string';
